import "./AsbestosLeadAbatement.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Overview from "./sections/Overview";
import WhyChoose from "./sections/WhyChoose";
import Intake from "./sections/Intake";
import Footer from "@/reusable_sections/Footer";
export default function AsbestosLeadAbatementPage() {
  return <div>
      <Header />
      <Hero />
      <Overview />
      <WhyChoose />
      <Intake />
      <Footer />
    </div>;
}